export default __webpack_public_path__ + "static/media/gallery_08.cbf7e5ec.jpg";